module.exports = "<div>\n    <cms-grid grid-options=\"$ctrl.options\"\n              datasource=\"$ctrl.datasource\"\n              initial-sort-model=\"$ctrl.initialSortModel\"\n              initial-filter-model=\"$ctrl.initialFilterModel\"\n              on-page-change=\"$ctrl._onPageChange($page)\"></cms-grid>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/cmsCore/PagesModules/PagesGrid/pages-grid.html
// module id = 997
// module chunks = 0